<template>
  <div class="base-height_fullscreen">
    <div class="base-text-align__right base-margin__bottom-10">
      <el-button :disabled="handleSelectionList.length === 0" @click="copyIPList">{{
          $t('customCluster.previewIp.copy')
        }}
      </el-button>
      <el-button :disabled="handleSelectionList.length === 0" @click="exportIp">{{
          $t('customCluster.previewIp.export')
        }}
      </el-button>
      <el-button type="primary" @click="setIP">{{ $t('customCluster.previewIp.setIpHostnameMap') }}</el-button>
    </div>
    <el-table
      :key="JSON.stringify(previewListTable)"
      v-loading="previewListLoading"
      :data="previewListTable"
      :row-class-name="tableRowClassName"
      class="previewList-table"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.previewIp.hostname')"
        prop="hostname"
      >
      </el-table-column>
      <el-table-column
        :label="$t('customCluster.previewIp.ip')"
        prop="ip"
      >
      </el-table-column>
    </el-table>

    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.previewIp.setIpHostnameMap')"
      :visible.sync="hostRangeListVisible"
      append-to-body
      width="700px"
    >
      <el-table
        :key="JSON.stringify(hostRangeListForm)"
        :data="hostRangeListForm"
        height="500"
        style="width: 100%">
        <el-table-column
          :label="$t('customCluster.previewIp.hostnamePrefix')"
        >
          <template slot-scope="scope">
          <span>
             {{ scope.row.hostnamePattern }}
          </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customCluster.previewIp.startIp')"
        >
          <template slot-scope="scope">
            {{ formatIp(scope.row.startIp) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customCluster.previewIp.endIp')">
          <template slot-scope="scope">
            {{ formatIp(scope.row.endIp) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customCluster.previewIp.startIndex')"
          prop="indexStart">
        </el-table-column>
        <el-table-column
          :label="$t('customCluster.previewIp.indexDigits')"
          prop="indexLength">
        </el-table-column>
        <el-table-column :label="$t('customCluster.previewIp.actions')">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="editHostRangeList(scope.$index, scope.row)">
              {{ $t('customCluster.previewIp.edit') }}
            </el-button>
            <el-button size="small" type="text" @click="deleteHostRangeList(scope.$index)">
              {{ $t('customCluster.previewIp.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="base-text-align__right base-margin__right-20">
        <el-button class="base-marginTop__10" type="text" @click="addIpRange">
          {{ $t('customCluster.previewIp.addIpRange') }}
        </el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hostRangeListVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button @click="preview(hostRangeListForm, 'hostRangeListForm')">{{
            $t('customCluster.previewIp.previewIp')
          }}</el-button>
        <el-button type="primary" @click="setHostIPMap">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`${$t('customCluster.previewIp.ipRange')} ${info.subnetCidr}`"
      :visible.sync="previewHostRangeListVisible"
      append-to-body
      width="700px"
    >
      <div>
        <el-form ref="hostRangeListForm" label-width="90px">
          <div>
            <div class="ipBox">
              <div class="base-flex base-position__relative startIp_input">
                <span>{{ $t('customCluster.previewIp.startIp') }}</span>
                <el-input v-for="(item, ipStartIndex) in showHostRangeListForm.startIp" :key="ipStartIndex + 10"
                          v-model="item.value" :disabled="item.disabled" type="number">
                </el-input>
                <span>{{ $t('customCluster.previewIp.endIp') }}</span>
                <el-input v-for="(item, ipEndIndex) in showHostRangeListForm.endIp" :key="ipEndIndex + 100"
                          v-model="item.value" :disabled="item.disabled" type="number">
                </el-input>
              </div>
              <div class="tips_cls">{{ $t('customCluster.previewIp.reservedIpTip') }}</div>
              <div class="base-flex base-position__relative startIp_input">
                <span>{{ $t('customCluster.previewIp.hostnamePrefix') }}</span>
                <el-input v-model="showHostRangeListForm.hostnamePattern"
                          :placeholder="$t('customCluster.previewIp.enterHostname')"
                          class="div-width__180"></el-input>
                <span>{{ $t('customCluster.previewIp.startIndex') }}</span>
                <el-input v-model="showHostRangeListForm.indexStart" type="number"></el-input>
                <span>{{ $t('customCluster.previewIp.indexDigits') }}</span>
                <el-input v-model="showHostRangeListForm.indexLength" type="number"></el-input>
                <div class="preview_div--button base-cursor__pointer base-color__light_blue base-margin__top-5"
                     @click="previewTemporary">
                  {{ $t('customCluster.previewIp.preview') }}
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeHostList">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="doneEditHostRangeList">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="$t('customCluster.previewIp.previewIp')"
      :visible.sync="previewTemporaryVisible"
      append-to-body
      width="600px"
    >
      <div class="previewDialog_main--div">
        <el-table :data="previewTemporaryList" :row-class-name="tableRowClassName" class="base-width_fullscreen"
                  height="500">
          <el-table-column :label="$t('customCluster.previewIp.hostname')" prop="hostname"></el-table-column>
          <el-table-column :label="$t('customCluster.previewIp.ip')" prop="ip"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="exportPreviewIp(previewTemporaryList)">{{
              $t('customCluster.previewIp.export')
            }}</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>

import {postRequest} from '@/common/libs/request';
import {exportData} from '@/common/utils/utils';
import {UTIL} from "@/common/utils";

export default {
  name: 'name',
  data() {
    return {
      previewListTable: [],
      hostRangeListForm: [],
      previewListLoading: false,
      info: {},
      hostRangeListVisible: false,
      previewHostRangeListVisible: false,
      hostRangeListFormIndex: false,
      showHostRangeListForm: {},
      hostRangeListIndex: 0,
      defaultHostRangeListForm: {},
      previewTemporaryVisible: false,
      previewTemporaryList: [],
      handleSelectionList: [],
    };
  },

  created() {
    this.getSubclusterDetail();
  },
  methods: {
    // 打开 设置IP-Hostname映射表 弹窗
    setIP() {
      this.hostRangeListVisible = true;
    },

    // 预览临时Ip
    previewTemporary() {
      // 将startIp中的4段value合并成IP字符串
      const startIp = this.formatIp(this.showHostRangeListForm.startIp);
      const endIp = this.formatIp(this.showHostRangeListForm.endIp);
      const ipList = {
        ...this.showHostRangeListForm,
        indexStart: +this.showHostRangeListForm.indexStart,
        endIp,
        startIp, // 添加合并后的IP字段
      };
      this.previewTemporaryList = this.generateIpArray(ipList);
      this.previewTemporaryVisible = true;
    },

    /**
     * 添加IP段
     */
    addIpRange() {
      if (!this.hostRangeListForm.length) return; // 防御性编程，防止空数组

      const defaultData = JSON.parse(JSON.stringify(this.hostRangeListForm[0]));

      // 清空可编辑的IP段值
      const clearIpValues = (ipArray) =>
        ipArray.map(item => (!item.disabled ? {...item, value: ''} : item));

      defaultData.startIp = clearIpValues(defaultData.startIp);
      defaultData.endIp = clearIpValues(defaultData.endIp);
      defaultData.hostnamePattern = '';
      defaultData.indexStart = '';
      defaultData.indexLength = 3;

      this.hostRangeListType = 'add';
      this.previewHostRangeListVisible = true;
      this.showHostRangeListForm = defaultData;
    },

    // 修改子集群HostIP映射关系
    setHostIPMap() {
      const data = {
        hostRangeList: this.hostRangeListFormDone(),
        subclusterId: Number(this.$route.query.id),
      };

      if (!data.hostRangeList || data.hostRangeList.length === 0) return this.$message.error(this.$t('customCluster.previewIp.fillIpRange'));
      postRequest('/api/eda/common/subcluster/setHostIPMap', data).then(() => {
        this.$message.success(this.$t('customCluster.previewIp.modifySuccess'));
        this.hostRangeListVisible = false;
        this.getSubclusterDetail();
      });
    },

    // 完成编辑IP段
    doneEditHostRangeList() {
      if (this.hostRangeListType === 'edit') {
        this.hostRangeListForm[this.hostRangeListIndex] = this.showHostRangeListForm;
      } else {
        if (this.clusterType === 'create' && !this.hostRangeListFormIndex) {
          this.hostRangeListFormIndex = true;
          this.hostRangeListForm[0] = this.showHostRangeListForm;
        } else {
          this.hostRangeListForm.push(this.showHostRangeListForm);
        }
      }
      this.previewHostRangeListVisible = false;
    },

    // js函数
    // 格式化IP
    formatIp(item) {
      if (Array.isArray(item)) {
        return item.map(ipPart => ipPart.value).join('.');
      } else {
        return item;
      }
    },

    // 编辑IP段
    editHostRangeList(index, item) {
      this.hostRangeListType = 'edit';
      this.showHostRangeListForm = JSON.parse(JSON.stringify(item));
      this.previewHostRangeListVisible = true;
      this.hostRangeListIndex = index;
    },

    // 删除IP段
    deleteHostRangeList(index) {
      if (this.hostRangeListForm.length === 1) {
        return this.$message.error(this.$t('customCluster.previewIp.keepOneIpRange'));
      }
      this.hostRangeListForm.splice(index, 1);
    },

    // 取消添加IP
    closeHostList() {
      this.previewHostRangeListVisible = false;
    },

    /**
     * 获取集群详情
     * */
    getSubclusterDetail() {
      if (!this.$route.query.id) return;
      this.previewListLoading = true;
      const data = {
        subclusterId: Number(this.$route.query.id),
      };
      postRequest('/api/eda/common/subcluster/getSubclusterDetail', data).then((res) => {
        this.info = res.subclusterDetail;
        this.preview(this.info.hostRangeList, 'home');
        this.analysisIpRange(this.info.hostRangeList, this.info.subnetCidr);
        this.previewListLoading = false;
      }).catch(() => {
        this.previewListLoading = false;
      });
    },

    /**
     * 复制集群时
     * 分析ip范围
     * 重新解析ip范围，并更新表单数据
     * */
    analysisIpRange(list, cidr) {
      const cidrList = cidr.split('.');
      const maskLength = Number(cidrList[3].substring(cidrList[3].indexOf('/') + 1));

      // 根据掩码长度计算需要禁用的IP段数量
      const getDisabledCount = (mask) => {
        if (mask < 16) return 1;
        if (mask < 24) return 2;
        return 3;
      };
      const disabledCount = getDisabledCount(maskLength);

      const ipList = list.map((item) => {
        // 处理IP段的通用函数
        const processIp = (ip) => ip.split('.').map((part, index) => ({
          value: part,
          disabled: index < disabledCount  // 根据需要禁用的数量设置状态
        }));

        item.startIp = processIp(item.startIp);
        item.endIp = processIp(item.endIp);

        return item;
      });

      this.hostRangeListForm = ipList;
    },

    /**
     * 预览IP*/
    preview(list, type) {
      const listView = JSON.parse(JSON.stringify(list));
      if (type === 'home') {
        // 将startIp中的4段value合并成IP字符串
        const ipListTable = [];
        listView.forEach((item, index) => {
          ipListTable.push(this.generateIpArray(item, index));
        });

        const data = ipListTable.flat();
        this.previewListTable = data.sort((a, b) => this.ipToNumber(a.ip) - this.ipToNumber(b.ip));
      } else {
        const ipListTable = [];
        listView.forEach((item, index) => {
          item.startIp = this.formatIp(item.startIp);
          item.endIp = this.formatIp(item.endIp);
          ipListTable.push(this.generateIpArray(item, index));
        });
        const data = ipListTable.flat();
        this.previewTemporaryList = data.sort((a, b) => this.ipToNumber(a.ip) - this.ipToNumber(b.ip));
        this.previewTemporaryVisible = true;
      }
    },

    /**
     * 将IP地址字符串转换成数字，方便递增计算
     * 例如 "172.16.0.1" => 数字形式
     * @param {string} ip - 点分十进制IP地址
     * @returns {number} - 转换后的数字
     */
    ipToNumber(ip) {
      return ip.split('.').reduce((acc, octet) => (acc << 8) + Number(octet), 0);
    },

    /**
     * 将数字转换回IP地址字符串
     * 例如 数字 => "172.16.0.1"
     * @param {number} num - IP的数字形式
     * @returns {string} - 点分十进制IP地址
     */
    numberToIp(num) {
      return [
        (num >> 24) & 0xff,
        (num >> 16) & 0xff,
        (num >> 8) & 0xff,
        num & 0xff,
      ].join('.');
    },


    /**
     * 将数字转换成固定长度字符串，前面补0
     * 例如 padNumber(5, 3) => "005"
     * @param {number} num - 需要格式化的数字
     * @param {number} length - 固定长度
     * @returns {string} - 补0后的字符串
     */
    padNumber(num, length) {
      return num.toString().padStart(length, '0');
    },

    /**
     * 根据起始IP和结束IP生成IP数组，每个元素包含ip和hostname
     * hostname = hostnamePattern + 固定长度补0的index
     * @param {Object} params
     * @param {string} params.startIp - 起始IP地址
     * @param {string} params.endIp - 结束IP地址
     * @param {string} params.hostnamePattern - 主机名前缀
     * @param {number} params.indexLength - index长度，hostname中index部分固定宽度
     * @param {number} params.indexStart - index起始值
     * @returns {Array} - 生成的数组，每个元素格式：{ ip: string, hostname: string }
     */
    generateIpArray({startIp, endIp, hostnamePattern, indexLength, indexStart}, indexNumber) {
      const startNum = this.ipToNumber(startIp); // 起始IP数字
      const endNum = this.ipToNumber(endIp);  // 结束IP数字
      const result = [];
      let index = indexStart;

      // 从起始IP数字递增到结束IP数字，生成IP数组
      for (let ipNum = startNum; ipNum <= endNum; ipNum++) {
        const ipStr = this.numberToIp(ipNum);
        const fourthOctet = Number(ipStr.split('.')[3]);

        // 如果第四段是0,1,255，跳过该IP，不加入结果，但index依然递增
        if (fourthOctet === 0 || fourthOctet === 1 || fourthOctet === 255) {
          continue;
        }

        result.push({
          ip: this.numberToIp(ipNum), // 当前IP字符串
          hostname: hostnamePattern + this.padNumber(index, indexLength), // 拼接hostname
          indexNumber, // 序号
        });
        // eslint-disable-next-line no-plusplus
        index++;
      }

      return result;
    },


    /**
     * 处理主机范围列表表单提交
     * 验证各项输入并格式化数据
     */
    hostRangeListFormDone() {
      try {
        // 主机名正则：字母开头，可包含字母数字、点号和连字符
        const hostNameReg = /^[a-zA-Z][a-zA-Z0-9]*([.-][a-zA-Z0-9]+)*([.-]?)$/;
        // 编号位数正则：正整数
        const indexPatternReg = /^[1-9]\d*$/;

        let hasError = false; // 标记是否有验证错误
        const ipList = this.hostRangeListForm.map((item, index) => {
          const indexNumber = index + 1; // 用户可见的序号(从1开始)
          const startIp = item.startIp.map(ipPart => ipPart.value).join('.');
          const endIp = item.endIp.map(ipPart => ipPart.value).join('.');

          // 验证编号位数
          if (!item.indexLength) {
            this.$message.error(this.$t('customCluster.previewIp.enterIndexDigits', {index: indexNumber}));
            hasError = true;
            return null;
          }
          if (!indexPatternReg.test(item.indexLength)) {
            this.$message.error(this.$t('customCluster.previewIp.invalidIndexDigits', {index: indexNumber}));
            hasError = true;
            return null;
          }

          // 验证主机名
          if (!item.hostnamePattern) {
            this.$message.error(this.$t('customCluster.previewIp.enterHostnameIndex', {index: indexNumber}));
            hasError = true;
            return null;
          }
          if (item.hostnamePattern.length >= 60 - Number(item.indexLength)) {
            this.$message.error(this.$t('customCluster.previewIp.hostnameTooLong', {index: indexNumber}));
            hasError = true;
            return null;
          }
          if (!hostNameReg.test(item.hostnamePattern)) {
            this.$message.error(this.$t('customCluster.previewIp.invalidHostname', {index: indexNumber}));
            hasError = true;
            return null;
          }
          // indexStart 和 indexLength 可以为0

          if (!item.indexStart) {
            this.$message.error(this.$t('customCluster.previewIp.enterStartIndex', {index: indexNumber}));
            hasError = true;
            return null;
          }

          // if (item.indexStart === 0) {
          //   this.$message.error(`第${indexNumber}项的起始编号不能为0`);
          //   hasError = true;
          //   return null;
          // }

          if (!item.indexLength) {
            this.$message.error(this.$t('customCluster.previewIp.indexDigitsCannotBeNone', {index: indexNumber}));
            hasError = true;
            return null;
          }

          if (item.indexLength === 0) {
            if (endIp !== startIp) {
              this.$message.error(this.$t('customCluster.previewIp.indexDigitsCannotBeZero', {index: indexNumber}));
              hasError = true;
              return null;
            }
          }

          // 返回格式化后的有效数据
          return {
            ...item,
            indexStart: Number(item.indexStart),
            indexLength: Number(item.indexLength),
            endIp,
            startIp,
          };
        }).filter(Boolean); // 过滤掉验证失败的null项

        // 如果有任何验证错误，不继续执行
        if (hasError) {
          return;
        }

        return ipList;
        // 所有验证通过，更新数据并触发事件
        // this.hostRangeList = ipList;
        // this.$emit('doneFillIp');
      } catch (e) {
        console.error('处理主机范围列表时出错:', e);
        this.$message.error(this.$t('customCluster.previewIp.processError'));
      }
    },

    // 导出预览IP
    exportPreviewIp(item) {
      const result = item.map(item => ({
        name: item.hostname,
        ip: item.ip,
      }));
      exportData(result, this.$t('customCluster.previewIp.previewIp'));
    },

    // 勾选列表
    handleSelectionChange(val) {
      this.handleSelectionList = val;
    },

    // 设置列表颜色
    tableRowClassName({row}) {
      return `table_color_${row.indexNumber % 20}`; // 循环使用20种颜色
    },

    // 复制数据
    copyIPList() {
      const result = this.parseHosts(this.handleSelectionList, [
        {
          label: 'hostname',
          prop: 'hostname',
        },
        {
          label: 'ip',
          prop: 'ip',
        },
      ]);
      UTIL.copyText(this, result);
    },

    // 解析函数
    parseHosts(hosts, format) {
      return hosts.map(host => format.map(item => host[item.prop]).join(' '), // 按照 format 中的顺序拼接字符串
      ).join('\n');
    },

    // 导出数据
    exportIp() {
      const result = this.handleSelectionList.map(item => ({
        HostName: item.hostname,
        IP: item.ip,
      }));
      exportData(result, this.$t('customCluster.previewIp.ipHostnameMap'));
    },
  },
};
</script>
<style lang="scss" scoped>
.previewList-table {
  height: calc(100% - 68px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 68px);
    overflow-y: auto;
  }
}

.ipBox {
  height: 126px;
  padding: 8px;
  margin-bottom: 10px;

  span {
    line-height: 36px;
    margin-right: 8px;
  }
}

.tips_cls {
  color: #999;
  font-size: 10px;
  margin-bottom: 14px;
}

.div-width__180 {
  width: 180px !important;
}

.startIp_input {
  .el-input {
    margin-right: 10px;
    width: 54px;
  }

  ::v-deep .el-input__inner {
    text-align: center;
    -moz-appearance: textfield;
  }

  ::v-deep .el-input__inner::-webkit-inner-spin-button,
  ::v-deep .el-input__inner::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
}
</style>
<style>
/* 淡雅绿色系 */
.table_color_0 {
  background-color: rgba(232, 245, 233, 0.3) !important;
}

/* 极浅绿 */
.table_color_1 {
  background-color: rgba(220, 237, 200, 0.3) !important;
}

/* 薄荷绿 */
.table_color_2 {
  background-color: rgba(200, 230, 201, 0.3) !important;
}

/* 嫩芽绿 */

/* 柔和蓝色系 */
.table_color_3 {
  background-color: rgba(227, 242, 253, 0.3) !important;
}

/* 淡天蓝 */
.table_color_4 {
  background-color: rgba(187, 222, 251, 0.3) !important;
}

/* 浅湖蓝 */
.table_color_5 {
  background-color: rgba(144, 202, 249, 0.3) !important;
}

/* 婴儿蓝 */

/* 浅灰紫色系 */
.table_color_6 {
  background-color: rgba(243, 229, 245, 0.3) !important;
}

/* 薰衣草 */
.table_color_7 {
  background-color: rgba(225, 190, 231, 0.3) !important;
}

/* 浅紫灰 */
.table_color_8 {
  background-color: rgba(209, 196, 233, 0.3) !important;
}

/* 淡丁香 */

/* 暖米色系 */
.table_color_9 {
  background-color: rgba(255, 248, 225, 0.3) !important;
}

/* 米白 */
.table_color_10 {
  background-color: rgba(255, 236, 179, 0.3) !important;
}

/* 浅香槟 */
.table_color_11 {
  background-color: rgba(255, 224, 178, 0.3) !important;
}

/* 杏黄 */

/* 冷灰色系 */
.table_color_12 {
  background-color: rgba(245, 245, 245, 0.3) !important;
}

/* 白灰 */
.table_color_13 {
  background-color: rgba(238, 238, 238, 0.3) !important;
}

/* 浅灰 */
.table_color_14 {
  background-color: rgba(224, 224, 224, 0.3) !important;
}

/* 中灰 */

/* 特殊混合色 */
.table_color_15 {
  background-color: rgba(224, 247, 250, 0.3) !important;
}

/* 冰蓝 */
.table_color_16 {
  background-color: rgba(232, 245, 233, 0.3) !important;
}

/* 水绿 */
.table_color_17 {
  background-color: rgba(241, 248, 233, 0.3) !important;
}

/* 玉绿 */
.table_color_18 {
  background-color: rgba(249, 251, 231, 0.3) !important;
}

/* 珍珠白 */
.table_color_19 {
  background-color: rgba(255, 253, 231, 0.3) !important;
}

/* 象牙白 */
</style>

